<template>
  <div class="info_wrapper">
    <!-- 上部 start-->
    <div class="info_top">
      <div class="product_name">{{ productName }}</div>
      <van-cell-group>
        <van-cell class="my_cell">
          <div class="my_cell_box">
            <div class="my_cell_label">投保方案</div>
            <div class="my_cell_content">
              <div
                :class="`content_case ${
                  currentCaseId === item.id ? 'active' : ''
                }`"
                v-for="(item, index) in productCases"
                :key="item.id"
                @click="handleCaseChange(item.id, index)"
              >
                {{ item.name }}
              </div>
            </div>
          </div>
        </van-cell>
		
		<div class="new_field_for_pc insurePeriod">
			<div>保险期间</div>
			<select class="field_select" @change="onSelectChange($event)">
				<option :selected="item.id==actionId" v-for="(item,index) in actions" :value="item.id">{{item.name}}</option>
			</select>
		</div>
        <van-cell class="my_cell insurePeriod" @click="showActionSheet = true">
          <div class="my_cell_box">
            <div class="my_cell_label">保险期间</div>
            <div class="my_cell_content">
              <div class="content">{{ actionTitle }}</div>
              <div class="iconfont icon-arrow icon_arrow_right"></div>
            </div>
          </div>
        </van-cell>
        <van-action-sheet
          v-model="showActionSheet"
          :actions="actions"
          cancel-text="取消"
          safe-area-inset-bottom
          @select="onSelect"
        />
		
		<div class="new_field_for_pc startDate">
			<div>起保日期</div>
			<date-picker :min="minChooseDate" class="field" v-model="startDate" type="date"/>
		</div>
        <van-cell class="my_cell startDate" @click="showCalendar = true">
          <div class="my_cell_box">
            <div class="my_cell_label">起保日期</div>
            <div class="my_cell_content">
              <div class="content_date">
                <div class="date_msg">{{ startDate }}</div>
                <div class="iconfont icon-calendar icon_calendar"></div>
              </div>
            </div>
          </div>
        </van-cell>
        <van-calendar
          color="#28CC77"
          :min-date="minChooseDate"
          v-model="showCalendar"
		  :defaultDate="defaultDate()"
          @confirm="onCalendarConfirm"
        />
      </van-cell-group>
    </div>
    <van-form>
      <!-- 投保人信息 -->
      <div class="policy_holder_info">
        <div class="info_header">
          <div class="header_msg">投保人信息</div>
          <!--暂时注释-->
          <!--          <div class="header_handle" @click="showPolicyHolderSheet = true">-->
          <!--            选择常用投保人-->
          <!--          </div>-->
        </div>
        <van-action-sheet
          v-model="showPolicyHolderSheet"
          class="policy_holder_box"
          @closed="handlePolicyHolderCancel"
        >
          <div class="policy_holder_content">
            <template v-if="policyHolderList.length">
              <div class="top_handle">
                <div class="btn btn_cancel" @click="handlePolicyHolderCancel">
                  取消
                </div>
                <div
                  v-if="policyHolderList.length"
                  class="btn btn_confirm"
                  @click="handlePolicyHolderConfirm"
                >
                  确定
                </div>
              </div>
              <div class="btn_add_policyHolder">
                <div class="iconfont icon-add-round icon_add"></div>
                <div>新增常用投保人</div>
              </div>
              <div class="policy_holder_list">
                <van-radio-group
                  v-model="currentRadioName"
                  @change="handleRadioChange"
                >
                  <van-cell-group>
                    <van-cell
                      clickable
                      class="radio_box"
                      v-for="(item, index) in policyHolderList"
                      :key="index"
                      @click="currentRadioName = `${index + 1}`"
                    >
                      <div class="left">
                        <div
                          class="iconfont icon-change icon_edit_pen"
                          @click.stop="jumpAddManagement($event, item.id)"
                        ></div>
                        <div class="user_info">
                          <div class="name">张三</div>
                          <div class="card_id">证件号：32123213901231290</div>
                        </div>
                      </div>
                      <template #right-icon>
                        <van-radio
                          :name="`${index + 1}`"
                          checked-color="#28CC77"
                        />
                      </template>
                    </van-cell>
                  </van-cell-group>
                </van-radio-group>
              </div>
            </template>
            <template v-else>
              <div class="top_handle">
                <div class="btn btn_close" @click="handlePolicyHolderCancel">
                  X
                </div>
              </div>
              <div class="empty_txt">暂未添加常用投保人～</div>
              <div class="btn_empty_add" @click="jumpAddManagement($event)">
                添加常用投保人
              </div>
            </template>
          </div>
        </van-action-sheet>
        <van-field
          class="my_field"
          name="policyHolderType"
          checked-color="#07c160"
          label="投保人类型"
          icon-size=".24rem"
          input-align="right"
          label-class="my_field_label"
          :required="true"
        >
          <template #input>
            <van-radio-group
              v-model="policyHolderType"
              direction="horizontal"
              @change="handlepolicyHolderChange"
            >
              <van-radio
                class="radio_type"
                name="1"
                icon-size=".3rem"
                checked-color="#07c160"
                >企业</van-radio
              >
              <!-- <van-radio
                class="radio_type"
                name="2"
                icon-size=".3rem"
                checked-color="#07c160"
                >个人</van-radio
              > -->
            </van-radio-group>
          </template>
        </van-field>
        <template v-if="+policyHolderType === 1">
          <van-field
            class="my_field"
            v-model="companyName"
            name="companyName"
            label="公司名称"
            placeholder="请输入公司名称"
            input-align="right"
            label-class="my_field_label"
            :required="true"
          />
        </template>
        <template v-else>
          <van-field
            class="my_field"
            v-model="personalName"
            name="personalName"
            label="姓名"
            placeholder="请输入投保人姓名"
            input-align="right"
            label-class="my_field_label"
            :required="true"
          />
        </template>

		<div class="new_field_for_pc">
			<div>证件类型</div>
			<select class="field_select" @change="policyHolderCertificatIdSelected($event)">
				<option value="">请选择证件类型</option>
				<option v-for="item in companyCertificatTypes" :value="item.id">{{item.value}}</option>
			</select>
		</div>
        <van-field
          class="my_field PolicyHolderCertificat"
          :value="policyHolderCertificat"
          name="policyHolderCertificat"
          label="证件类型"
          placeholder="请选择证件类型"
          input-align="right"
          label-class="my_field_label"
          readonly
          is-link
          required
          @click="showPolicyHolderCertificatPicker = true"
        ></van-field>
        <van-popup v-model="showPolicyHolderCertificatPicker" position="bottom">
          <van-picker
            title="证件类型"
            show-toolbar
            value-key="value"
            :default-index="defaultPickerIndex"
            :columns="
              +policyHolderType === 1
                ? companyCertificatTypes
                : personalCertificatTypes
            "
            @confirm="onCertificatTypesConfirm"
            @cancel="showPolicyHolderCertificatPicker = false"
          />
        </van-popup>
        <template v-if="+policyHolderType === 1">
          <van-field
            class="my_field"
            v-model="creditCode"
            name="creditCode"
            label="社会信用代码"
            placeholder="请输入社会信用代码"
            input-align="right"
            label-class="my_field_label"
            :required="true"
			maxlength="20"
          />
		  
		<div class="new_field_for_pc city">
			<div>省市区</div>
			<v-distpicker :placeholders="placeholders" @selected="onSelected" :province="cityData.province" :city="cityData.city" :area="cityData.area"></v-distpicker>
		</div>
          <van-field
            class="my_field city"
            readonly
            clickable
            name="area"
            :value="areaValue"
            input-align="right"
            label-class="my_field_label"
            label="省市区"
            required
            placeholder="请选择省市区"
            @click="showArea = true"
          />
          <van-popup v-model="showArea" position="bottom">
            <van-area
              :area-list="areaList"
              :value="defauleCountyCode"
              @confirm="onAreaConfirm"
              @cancel="showArea = false"
            />
          </van-popup>

          <van-field
            class="my_field"
            v-model="companyAddress"
            name="companyAddress"
            label="公司地址"
            placeholder="请输入公司地址"
            input-align="right"
            label-class="my_field_label"
            :required="true"
          />
        </template>
        <template v-else>
          <van-field
            class="my_field"
            v-model="personalIdCardNum"
            name="personalIdCardNum"
            label="证件号码"
            placeholder="请输入证件号码"
            input-align="right"
            label-class="my_field_label"
            :required="true"
          />
          <van-field
            class="my_field"
            v-model="personalPhoneNum"
            name="personalPhoneNum"
            label="手机号码"
            placeholder="请输入手机号码"
            input-align="right"
            label-class="my_field_label"
            :required="true"
          />
          <template v-if="policyHolderCertificatId > 1">
            <van-field
              class="my_field"
              v-model="personalGender"
              name="personalGender"
              label="性别"
              input-align="right"
              label-class="my_field_label"
              :required="true"
            >
              <template #input v-if="policyHolderCertificatId > 1">
                <div class="gender_box">
                  <div
                    @click="personalGender = 1"
                    :class="`gender_item ${
                      +personalGender === 1 ? 'active' : ''
                    }`"
                  >
                    男
                  </div>
                  <div
                    @click="personalGender = 2"
                    :class="`gender_item ${
                      +personalGender === 2 ? 'active' : ''
                    }`"
                  >
                    女
                  </div>
                </div>
              </template>
            </van-field>
            <van-field
              class="my_field"
              v-model="birthday"
              readonly
              clickable
              name="birthday"
              label="出生日期"
              placeholder="请选择出生日期"
              input-align="right"
              label-class="my_field_label"
              :required="true"
              @click="showPolicyHolderPicker = true"
            >
              <template #input>
                <div class="birthday">
                  <div class="date_msg">
                    {{ birthday || '请选择出生日期' }}
                  </div>
                  <div class="iconfont icon-calendar icon_calendar"></div>
                </div>
              </template>
            </van-field>
            <van-popup v-model="showPolicyHolderPicker" position="bottom">
              <van-datetime-picker
                type="date"
                v-model="currentDate"
                :min-date="minDate"
                :formatter="formatterDate"
                @confirm="onPolicyHolderPickerConfirm"
                @cancel="showPolicyHolderPicker = false"
              />
            </van-popup>
          </template>
          <template v-else></template>
        </template>
      </div>
      <!-- 被保人信息 -->
      <div class="insured_info">
        <div class="info_header">
          <div class="header_msg">被保人信息</div>
        </div>
        <div class="write_type_box">
          <div class="type" @click="handleWrite">
            {{ !insuredInfoList.length ? '手动输入' : '继续添加' }}
          </div>
          <div class="type" @click="goWriteInfoPage">身份证识别</div>
        </div>
		<div v-show="+productId == 157" class="insured_type_radio_for_pc">
			<div class="radio_desc">
				投保方式:
			</div>
			<div class="radio_div">
				<van-radio-group v-model="insuredRadio">
				  <van-radio name="0">1.一单一人：每个被保险人有各自的保单号码和电子保单。</van-radio>
				  <van-radio name="1">2.一单多人：所有被保险人都在同一保单中。</van-radio>
				</van-radio-group>
			</div>
		</div>
		<div class="write_type_box_for_pc" style="display: none;">
		  <div class="type" @click="handlePolicyWrite">
		    {{ !insuredInfoList.length ? '添加' : '继续添加' }}
		  </div>
		  <div class="type" @click="toggleModal">简单粘贴</div>
		  <div class="upload_file_box_for_pc">
		    <div class="type" @click="uploadFile">
		        <div id="uploadify"><input @change="getFile($event)" ref="myUploader" id="select_btn_1" class="selectbtn" style="display:none;" type="file" name="fileselect[]" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"><a id="file_upload_1-button" href="javascript:void(0)" class="uploadify-button">选择文件</a><div id="file_upload_1-queue" class="uploadify-queue"></div></div>
		    </div>
		    <div class="dolownload_div"><a class="upload_a" href="http://e.dasurebao.com.cn/policybilling/sales/Insured_Template.xls">下载批量导入模板</a></div>
		  </div>
		</div>
        <div class="insured_info_list">
          <InsuredInfoItem
            v-for="(item, index) in insuredInfoList"
            :key="index"
            :insuredInfo="item"
            :index="index"
            :delOne="delOne"
			:mobileIdNumberChange="mobileIdNumberChange"
          />
        </div>
		<div class="insured_info_list_for_pc" v-if="insuredInfoList.length">
			<div class="table_header">
				<div class="table_header_item squence">序号</div>
				<div class="table_header_item name">姓名</div>
				<div class="table_header_item vertificateType">证件类型</div>
				<div class="table_header_item vertificateNumber">证件号码</div>
				<div class="table_header_item birthday">出生日期</div>
				<div class="table_header_item gender">性别</div>
				<div class="table_header_item operation">操作</div>
			</div>
		  <InsuredInfoPCItem
		    v-for="(item, index) in insuredInfoList"
		    :key="index"
		    :insuredInfo="item"
		    :index="index"
		    :delOne="delOne"
			:editOne="editOne"
			v-on:confirmInsuredCertificatId="confirmInsuredCertificatId"
			:genderList="genderList"
			:insuredCertificatIdList="insuredCertificatIdList"
		  />
		</div>
      </div>

      <!-- <div style="margin: 16px">
          <van-button round block type="info" @click="handleConfirm">
            提交
          </van-button>
              </div>-->
      <div class="form_bottom_box">
        <div class="check_box">
          <van-checkbox
            icon-size=".26rem"
            checked-color="#28cc77"
            v-model="checked"
            label-disabled
          >
            <span>我已阅读</span>
            <span class="link" @click="jumpNeed">《投保须知及声明》、</span>
            <span class="link" @click="jumpTiaoKuan">《条款详情》</span>
          </van-checkbox>
        </div>
        <!-- pdf弹出框 -->
        <van-action-sheet
          v-model="showPdfFlag"
          title="投保须知及声明"
          class="actionBox"
        >
          <div class="content">
            <div class="pdf_content"></div>
          </div>
        </van-action-sheet>
        <div class="bottom_handle">
          <div class="price">{{ `${insuredInfoList.length * total}元` }}</div>
          <div class="handle_btn" @click="handleConfirm">立即投保</div>
        </div>
      </div>
    </van-form>
	<Modal v-show="showModal" v-on:closeme="closeme" v-on:confirmTextArea="confirmTextArea" :insuredInfoList="insuredInfoList"></Modal>
	<PolicyModal 
			v-show="showPolicyModal" 
			v-on:closepolicyme="closepolicyme" 
			v-on:confirmPolicy="confirmPolicy" 			
			:genderList="genderList"
			:insuredCertificatIdList="insuredCertificatIdList"
			:insuredInfoList="insuredInfoList"
			:editData="editData"
			:addEditType="addEditType">
	</PolicyModal>
	<WriteInformationModal
			v-show="showWriteInformationModal" 
			:isShow="showWriteInformationModal"
			v-on:closewriteinformationme="closewriteinformationme" 
			v-on:confirmWriteinformation="confirmWriteinformation">
	</WriteInformationModal>
	<IFrameModal :url="url" v-show="showIFrameModal" v-on:closeiframe="closeiframe"/>
  </div>
</template>

<script>
import "./InfoForm.less";
// 引入pdf插件
import Pdfh5 from "pdfh5";
import "pdfh5/css/pdfh5.css";
import { getProductInsuredAttr, getPremium, getPayParams } from '../../api/api'
import {
  Area,
  Calendar,
  Cell,
  CellGroup,
  Field,
  Form,
  Picker,
  Popup,
  Radio,
  RadioGroup,
  Notify,
  Checkbox,
  DatetimePicker,
  ActionSheet,
  Toast,
} from "vant";
import areaList from "../../libs/js/areaList";
import InsuredInfoItem from "@/components/InsuredInfoItem/InsuredInfoItem.vue";
import InsuredInfoPCItem from "@/components/InsuredInfoPCItem/InsuredInfoPCItem.vue";
import Modal from "@/components/Modal.vue";
import PolicyModal from "@/components/PolicyModal.vue";
import IFrameModal from "@/components/IFrameModal.vue";
import WriteInformationModal from "@/components/WriteInformationModal.vue";
import { verifyCardNo, isMobile, getCardNoSex, getBirthdayFromIdCard,identifyText,formatExcelDate,findKey,getAge,analyzeIDCard } from "../../utils/verifyUtils";
import { SectionToChinese } from "../../utils/sectionToChinese";
import dayjs from "../../libs/js/day";
import { savePolicy, getUserInfor,saveInsuredInfo,getArea } from '../../api/api'
import '@vant/touch-emulator';
import XLSX from 'xlsx'
import wx from 'weixin-js-sdk'
import DatePicker from '@hyjiacan/vue-datepicker'
import '@hyjiacan/vue-datepicker/dist/datepicker.css'
import VDistpicker from 'v-distpicker'
export default {
  name: "InfoForm",
  data() {
    return {
	  serverAreaList:[],
	  ageRule:{
	  	'PK00029011':{
	  		'min':16,
	  		'max':65
	  	},
	  	'PK00029001':{
	  		'min':16,
	  		'max':65
	  	},
	  	'QX000000128094':{
	  		'min':18,
	  		'max':65
	  	},
	  	'QX000000128095':{
	  		'min':18,
	  		'max':65
	  	},
	  	'QX000000128096':{
	  		'min':18,
	  		'max':65
	  	},
	  	'QX000000128097':{
	  		'min':18,
	  		'max':65
	  	},
	  	'QX000000128103':{
	  		'min':18,
	  		'max':65
	  	},
	  	'QX000000128101':{
	  		'min':18,
	  		'max':65
	  	},
	  	'QX000000128100':{
	  		'min':18,
	  		'max':65
	  	},
	  },
	  hardCodeInsuredData:{
	  	157:{
	  		'productCode':'',
	  		0:{
	  			'TYONE':'MP10450101-PK00029001',
	  			'TMONE':'',
	  		},
	  		1:{
	  			'TYONE':'MP10450101-PK00029011',
	  			'TMONE':'MP10450133-PK00029011',
	  		},
	  		2:{
	  			'TYONE':'MP10450102-PK00029001',
	  			'TMONE':'MP10450132-PK00029001',
	  		},
	  		3:{
	  			'TYONE':'MP10450102-PK00029011',
	  			'TMONE':'MP10450132-PK00029011',
	  		}
	  	},
	  	126:{
	  		'productCode':'QXYAYS',
	  		0:{
	  			'TYONE':'QX000000128096',
	  			'TMONE':'QX000000128094',
	  		},
	  		1:{
	  			'TYONE':'QX000000128097',
	  			'TMONE':'QX000000128095',
	  		},
	  	},
	  },
	  showIFrameModal:false,
	  url:'',
	  showWriteInformationModal:false,
	  companyCode:'',
	  placeholders: {
	      province: '------- 省 --------',
	      city: '--- 市 ---',
	      area: '--- 区 ---',
	  },
	  cityData: { province: '', city: '', area: '' },
	  insuredRadio:'0',
	  editIndex:-1,
	  addEditType:'add',
	  editData:{},
	  genderList:[
	  	{name:'男',value:1},
	  	{name:'女',value:2},
	  ],	
	  insuredCertificatIdList:[
	  	{name:'身份证',value:0},
	  	{name:'护照',value:2},
	  	{name:'其他',value:5},
	  ],
	  excelData:{
		  0:'insuredName',
		  1:'insuredCertificatId',
		  2:'insuredIdCardNum',
		  3:'birthday',
		  4:'insuredGender',
	  },
	  showPolicyModal:false,
	  showModal:false,
      timer: '',
      showPdfFlag: false,
      checked1: true,
      currentCaseId: 0,
      currentIndex: 0,
      showCalendar: false,
      policyHolderType: "1",
      startDate: dayjs().add(1, "day").format("YYYY-MM-DD"),
      minChooseDate: new Date(dayjs().add(1, "day")),
      companyName: "", // 公司名称
      personalName: "", // 投保人姓名
      showPolicyHolderCertificatPicker: false,
      companyCertificatTypes: [{ id: 1, value: "统一社会信用代码" }],
      personalCertificatTypes: [
        { id: 1, value: "身份证" },
        { id: 2, value: "军官证" },
        { id: 3, value: "护照" },
        { id: 4, value: "驾驶证" },
        { id: 5, value: "营业执照" },
        { id: 6, value: "其他" },
      ],
      personalIdCardNum: "", // 个人证件号码
      personalPhoneNum: "", // 个人手机号
      policyHolderCertificat: "", // 投保人证件类型
      policyHolderCertificatId: "", // 投保人证件类型Id
      defaultPickerIndex: 0, // 默认选中的证件类型索引
      creditCode: "", // 信用代码
      areaValue: "", // 省市区
      showArea: false,
      areaList: areaList, // 数据格式见 Area 组件文档
      companyAddress: "", // 公司地址
      personalGender: 1, // 性别
      showPolicyHolderPicker: false,
      birthday: "",
      // 被保人信息列表
      insuredInfoList: [],
      checked: false,
      indata: {
        inSuredPass: false,
      },
      minDate: new Date(1900, 1, 1),
      currentDate: new Date(),
      showActionSheet: false,
      period: "", // 年月
      periodId: "", //
      showPolicyHolderSheet: false,
      currentRadioName: 0, // 当前选中的投保人radio
      confirmRadioName: 0, // 点击确定后的radio
      policyHolderList: [{ id: 1 }],
      defauleCountyCode: "",
      price: "", // 方案价格
	  productIntro:"",
	  productPictureUrl:"",
      productName: '', // 产品名称
      productCases: [], // 投保方案
      actions: [], // 保险期间
      actionTitle: '', // 保险期间文案
      actionId: '',
      insurances: [],
      total: '', // 价格
      productId: this.$route.query.productId,
      productCode: '',
      userInfo: {},
    };
  },
  components: {
    "van-cell": Cell,
    "van-cell-group": CellGroup,
    "van-form": Form,
    "van-field": Field,
    "van-radio-group": RadioGroup,
    "van-radio": Radio,
    "van-checkbox": Checkbox,
    "van-popup": Popup,
    "van-picker": Picker,
    "van-area": Area,
    "van-calendar": Calendar,
    "van-datetime-picker": DatetimePicker,
    "van-action-sheet": ActionSheet,
    InsuredInfoItem,
	InsuredInfoPCItem,
	Modal,
	PolicyModal,
	DatePicker,
	VDistpicker,
	WriteInformationModal,
	IFrameModal,
  },
  async mounted() {
	  Toast.loading({
	    message: '加载中',
	    forbidClick: true,
	    duration: 0,
	    loadingType: 'spinner'
	  })
    this.getProductInsuredAttr()
    this.getOcrData()
	const area = await this.getServerArea('0')
	if(area.code == 200 && area.data.length){
		this.serverAreaList = area.data
	}
	Toast.clear()
    // this.getUserInfor()
    // document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false)
  },

  destroyed() {
    clearTimeout(this.timer);
  },

  methods: {
	  async getServerArea(code){
		  const area = await getArea({'code':code})
		  return area
	  },
	  mobileIdNumberChange(index){
		  const data = this.insuredInfoList[index]
		  const {insuredGender,insuredCertificatId,insuredIdCardNum} = data
		  if(insuredCertificatId == 0 && insuredIdCardNum){
			  let gender = 1
			  const newGender = identifyText(insuredIdCardNum + ' 测试')
			  if(newGender[0].insuredGender == 'F'){
			  	 gender = 2
			  }
			  data.insuredGender = gender
		  }
		  this.insuredInfoList[index] = data
	  },
	  defaultDate(){
		return new Date(this.startDate)  
	  },
	  onSelected(data) {
		  const {area,city,province} = data
	      this.areaValue = province.value + '-' + city.value + '-' + area.value
	  },
	  getFile(e){
		let that = this
		var files = e.target.files;
		var fileReader = new FileReader();
		fileReader.readAsBinaryString(files[0]);
		fileReader.onload = function(ev) {
		    try {
		        var data = ev.target.result
		        var workbook = XLSX.read(data, {
		            type: 'binary'
		        }) // 以二进制流方式读取得到整份excel表格对象
		        var persons = []; // 存储获取到的数据
		    } catch (e) {
		        console.log('文件类型不正确');
		        return;
		    }
		    // 表格的表格范围，可用于判断表头是否数量是否正确
		    var fromTo = '';
		    // 遍历每张表读取
		    for (var sheet in workbook.Sheets) {
		        if (workbook.Sheets.hasOwnProperty(sheet)) {
		            fromTo = workbook.Sheets[sheet]['!ref'];
		            console.log(fromTo);
		            persons = persons.concat(XLSX.utils.sheet_to_json(workbook.Sheets[sheet]));
		            // break; // 如果只取第一张表，就取消注释这行
		        }
		    }
		    //在控制台打印出来表格中的数据
			const dataArray = []
			let isRepeat = false
			persons.forEach((ele,index)=>{
				if(index != 0 && !isRepeat){
					const dataObject = {}
					let innerIndex = 0
					for(let key in ele){
						let value = ele[key]
						if(innerIndex === 1){
							const newvalue = that.insuredCertificatIdList.find(x=>x.name === value)
							if(newvalue){
								value = newvalue.value
							}
						}else if(innerIndex === 2){
							const cardIndex = that.insuredInfoList.findIndex(x=>x.insuredIdCardNum == value)
							if(cardIndex != -1){
								alert('请不要输入重复数据，证件号码与第'+(cardIndex+1)+'行重复')
								isRepeat = true
								return
							}
						}else if(innerIndex === 3){
							value = formatExcelDate(value)
						}else if(innerIndex === 4){
							const newvalue = that.genderList.find(x=>x.name == value)
							if(newvalue){
								value = newvalue.value
							}
						}
						dataObject[that.excelData[innerIndex]] = value
						innerIndex++
					}
					if(dataObject.insuredCertificatId == 0){
						dataObject.insuredCertificat = "身份证"
					}else if(dataObject.insuredCertificatId == 2){
						dataObject.insuredCertificat = "护照"
					}else if(dataObject.insuredCertificatId == 5){
						dataObject.insuredCertificat = "其他"
					}
					dataObject.insuredCertificatTypes =
					[
					  { id: 0, value: "身份证" },
					  { id: 1, value: "军官证" },
					  { id: 2, value: "护照" },
					  { id: 3, value: "驾驶证" },
					  { id: 4, value: "营业执照" },
					  { id: 5, value: "其他" },
					],
					dataObject.showInsuredCertificatPicker = false
					dataObject.showInsuredCalendar = false
					dataObject.minDate = new Date(1900, 1, 1)
					dataObject.currentDate = new Date()
					dataArray.push(dataObject)
				}
			})
			if(isRepeat){
				dataArray.length = 0
			}
			if(dataArray.length){
				that.insuredInfoList = that.insuredInfoList.concat(dataArray)
			}
		};
		document.querySelector("#select_btn_1").setAttribute('type','text');
		document.querySelector("#select_btn_1").setAttribute('type','file');
	  },
	  uploadFile(){
		  this.$refs.myUploader.click();
	  },
	 confirmInsuredCertificatId(CertificatIdData){
		 const {index,insuredCertificatId} = CertificatIdData
		 this.insuredInfoList[index]['insuredCertificatId'] = insuredCertificatId
	 },
	confirmTextArea(array){
		this.insuredInfoList = this.insuredInfoList.concat(array)
		this.showModal = false
	},
	confirmPolicy(value){
		const {addEditType,data} = value
		if(addEditType=='add'){
			this.insuredInfoList.push(data)
		}else{
			this.insuredInfoList[this.editIndex] = data
		}
		this.showPolicyModal = false
	},
	confirmWriteinformation(value){
		const ocrData = value
		let isReapt = false
		if (ocrData) {
		  ocrData.forEach(item => { 
			const repeatIndex = this.insuredInfoList.findIndex(x=>x.insuredIdCardNum == item.idNumber)
			if(repeatIndex != -1){
				alert("证件号码与被保人"+(repeatIndex + 1)+"重复")
				isReapt = true
				return
			}
		    this.insuredInfoList.push({
		      insuredName: item.name,
		      insuredGender: item.gender == 0?1:2,
		      insuredCertificatTypes: [
		        { id: 0, value: "身份证" },
		        { id: 1, value: "军官证" },
		        { id: 2, value: "护照" },
		        { id: 3, value: "驾驶证" },
		        { id: 4, value: "营业执照" },
		        { id: 5, value: "其他" },
		      ],
		      minDate: new Date(1900, 1, 1),
		      currentDate: new Date(),
		      insuredCertificat: "身份证",
		      insuredCertificatId: 0,
		      showInsuredCertificatPicker: false,
		      insuredIdCardNum: item.idNumber,
		      showInsuredCalendar: false,
		      birthday: item.birthDay,
		    });
		  })
		  this.$forceUpdate()
		}
		if(!isReapt){
			this.showWriteInformationModal = !this.showWriteInformationModal;
		}
	},
    toggleModal:function(){
      this.showModal = !this.showModal;
    },
    closeme:function(){
      this.showModal = !this.showModal;
	},
	closepolicyme:function(){
	  this.showPolicyModal = !this.showPolicyModal;
	},
	closewriteinformationme:function(){
	  this.showWriteInformationModal = !this.showWriteInformationModal;
	},
	closeiframe:function(){
	  this.showIFrameModal = !this.showIFrameModal;
	},
    async getUserInfor() {
      const data = await getUserInfor()
      this.userInfo = data.user
    },
    //   获取配置
    async getProductInsuredAttr() {
      const { productId } = this.$route.query
      const data = await getProductInsuredAttr({
        productid: productId,
      })
      const resData = data.productAttributes;
	  this.companyCode = resData.companyId
      // this.productCode = resData.productCode
	  this.productCode = resData.insurances[0].code
      this.productName = resData.productName
	  this.productIntro = resData.productIntro
	  this.productPictureUrl = resData.productPictureUrl
      this.productCases = resData.appProModuleExts.find(item => item.id === 40).appProAttributeExts[0].appProValues
      this.actions = resData.appProModuleExts.find(item => item.id === 40).appProAttributeExts[1].appProValues
      this.actions1 = resData.appProModuleExts.find(item => item.id === 40).appProAttributeExts[1].appProValues
      this.insurances = resData.insurances
      this.actionTitle = this.actions[0].name
      this.actionId = this.actions[0].id
      this.currentCaseId = this.productCases[0].id
      if (+this.productId === 157 && +this.currentIndex === 0) {
        this.actions = [this.actions1[0]]
        this.actionId = this.actions1[0].id
        this.actionTitle = this.actions1[0].name
      }
	  this.getPremium()
	  // const saveProduct = JSON.parse(localStorage.getItem('productInfo'))
	  // const caseid = saveProduct.currentCase.id
	  // if(this.currentCaseId != caseid){
	  // 	this.handleCaseChange(caseid,this.productCases.findIndex(x=>x.id == caseid))
	  // }else{
		 // this.getPremium()
	  // }
    },
    getOcrData() {
      const ocrData = JSON.parse(localStorage.getItem('ocrData'))
      if (ocrData) {
        ocrData.forEach(item => {
          this.insuredInfoList.push({
            insuredName: item.name,
            insuredGender: item.gender,
            insuredCertificatTypes: [
              { id: 0, value: "身份证" },
              { id: 1, value: "军官证" },
              { id: 2, value: "护照" },
              { id: 3, value: "驾驶证" },
              { id: 4, value: "营业执照" },
              { id: 5, value: "其他" },
            ],
            minDate: new Date(1900, 1, 1),
            currentDate: new Date(),
            insuredCertificat: "身份证",
            insuredCertificatId: 0,
            showInsuredCertificatPicker: false,
            insuredIdCardNum: item.idNumber,
            showInsuredCalendar: false,
            birthday: item.birthDay,
          });
        })
        this.$forceUpdate()
        localStorage.removeItem('ocrData')
      }
    },
    // 获取金额
    async getPremium() {
      const { actions, productCases, currentCaseId, actionId, insurances } = this.$data
      const paramsData = {
        products: [
          {
            amount: productCases.find(item => item.id === currentCaseId).value,
            copys: 1,
            insuranceId: insurances[0].id,
            insuranceterm: actions.find(item => item.id === actionId).value,
            payterm: insurances[0].payPeriod[0].propertyValue,
            productId: this.$route.query.productId,
          },
        ],
        customers: [],
      }
      const data = await getPremium(paramsData)
      this.total = data.total
    },
    // 选择年月触发函数
    onSelect(action) {
      this.actionId = action.id
      this.actionTitle = action.name
      this.showActionSheet = false;
      this.getPremium()
    },
	onSelectChange($event) {
		const selectedIndex = $event.target.options.selectedIndex
		const action = this.actions[selectedIndex]
		const {id,name} = action
		this.actionId = id
		this.actionTitle = name
		this.getPremium()
	},
    handlePDF() {
      this.showPdfFlag = true; // 展示弹框
      this.$nextTick(() => {
        setTimeout(() => {
          if (!this.pdfh5) {
            //实例化
            this.pdfh5 = new Pdfh5(".pdf_content", {
              pdfurl: "/api/mini-yidongbao/213.pdf",
            });
            //监听完成事件
            this.pdfh5.on("complete", function (status, msg, time) {
              console.log(
                "状态：" +
                status +
                "，信息：" +
                msg +
                "，耗时：" +
                time +
                "毫秒，总页数：" +
                this.totalNum
              );
            });
          }
        }, 500);
      });
    },
    jumpNeed() {
		this.showIFrameModal = true
		this.url = window.location.origin + '/policyDeclaration?productId=' + this.$route.query.productId
      // this.$router.push({
      //   path: '/policyDeclaration',
      //   query: {
      //     productId: this.$route.query.productId
      //   }
      // })
    },
    jumpTiaoKuan() {
		this.showIFrameModal = true
		this.url = window.location.origin + '/termsDetail?pid=' + this.$route.query.productId
      // this.$router.push({
      //   path: '/termsDetail',
      //   query: {
      //     pid: this.$route.query.productId
      //   }
      // })
    },
    // 投保人类型切换
    handlepolicyHolderChange() {
      this.resetPolicyHolderInfo();
    },

    // 投保人证件类型确认
    onCertificatTypesConfirm(value, index) {
      this.policyHolderCertificat = value.value;
      this.policyHolderCertificatId = value.id;
      this.showPolicyHolderCertificatPicker = false;
    },
	policyHolderCertificatIdSelected($event){
		const selectedIndex = $event.target.options.selectedIndex
		if(selectedIndex > 0){
			const selectdata = this.companyCertificatTypes[selectedIndex - 1]
			this.policyHolderCertificat = selectdata.value;
			this.policyHolderCertificatId = selectdata.id;
		}
	},
    // 省市区确认
    onAreaConfirm(values) {
      this.areaValue = values
        .filter((item) => !!item)
        .map((item) => item.name)
        .join("-");
      this.showArea = false;
	  this.cityData = { province: values[0].name, city: values[1].name , area: values[2].name }
    },
    formatterDate(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      } else if (type === "day") {
        return `${val}日`;
      }
      return val;
    },
    // 重置投保人信息
    resetPolicyHolderInfo() {
      this.companyName = "";
      this.policyHolderCertificatId = "";
      this.policyHolderCertificat = "";
      this.creditCode = "";
      this.areaValue = "";
      this.companyAddress = "";
      this.defauleCountyCode = "";
      this.personalName = "";
      this.personalIdCardNum = "";
      this.personalPhoneNum = "";
      this.personalGender = 1;
      this.birthday = "";
      this.policyHolderCertificatId = 1;
      this.policyHolderCertificat = "";
      this.defaultPickerIndex = 0;
      this.currentDate = new Date();
    },
    onPolicyHolderPickerConfirm(date) {
      this.birthday = dayjs(date).format("YYYY-MM-DD");
      this.showPolicyHolderPicker = false;
    },
    // 跳转身份证验证页面
    goWriteInfoPage() {
		this.showWriteInformationModal = !this.showWriteInformationModal
      // this.$router.push("/WriteInformation");
    },
    // 点击方案处理函数
    handleCaseChange(id, index) {
      if (id === this.currentCaseId) return;
      this.currentIndex = index
      this.currentCaseId = id;
      if (+this.productId === 157 && +this.currentIndex === 0) {
        this.actions = [this.actions1[0]]
        this.actionId = this.actions1[0].id
        this.actionTitle = this.actions1[0].name
      } else {
        this.actions = this.actions1
      }
      this.getPremium()
    },
    onCalendarConfirm(date) {
      this.startDate = dayjs(date).format("YYYY-MM-DD");
      this.showCalendar = false;
    },

    handleWrite() {
      this.insuredInfoList.push({
        insuredName: "",
        insuredGender: 2,
        insuredCertificatTypes: [
          { id: 0, value: "身份证" },
          { id: 1, value: "军官证" },
          { id: 2, value: "护照" },
          { id: 3, value: "驾驶证" },
          { id: 4, value: "营业执照" },
          { id: 5, value: "其他" },
        ],
        minDate: new Date(1900, 1, 1),
        currentDate: new Date(),
        insuredCertificat: "",
        insuredCertificatId: "",
        showInsuredCertificatPicker: false,
        insuredIdCardNum: "",
        showInsuredCalendar: false,
        birthday: dayjs().format("YYYY-MM-DD"),
      });
    },
	handlePolicyWrite() {
		this.editData = {
			  insuredName: "",
			  insuredGender: 1,
			  insuredCertificatTypes: [
			    { id: 0, value: "身份证" },
			    { id: 1, value: "军官证" },
			    { id: 2, value: "护照" },
			    { id: 3, value: "驾驶证" },
			    { id: 4, value: "营业执照" },
			    { id: 5, value: "其他" },
			  ],
			  minDate: new Date(1900, 1, 1),
			  currentDate: new Date(),
			  insuredCertificat: "身份证",
			  insuredCertificatId: 0,
			  showInsuredCertificatPicker: false,
			  insuredIdCardNum: "",
			  showInsuredCalendar: false,
			  birthday: "",
		}
	  this.showPolicyModal = true;
	  this.addEditType = 'add'
	},
    delOne(index) {
      this.insuredInfoList.splice(index, 1)
    },
	editOne(index) {
	  const newData = {}
	  for(let key in this.insuredInfoList[index]){
	  	newData[key] = this.insuredInfoList[index][key]
	  }
	  this.editData = newData
	  this.showPolicyModal = true
	  this.addEditType = 'edit'
	  this.editIndex = index
	},
    handleRadioChange(name) {
      // console.log(name)
    },
    jumpAddManagement(e, addressId) {
      // console.log(addressId);
      this.$router.push({
        path: "/addManagement",
        query: {
          addressId,
        },
      });
    },
    handlePolicyHolderConfirm() {
      if (!this.currentRadioName) {
        Notify("请选择常用投保人");
        return;
      }
      this.confirmRadioName = this.currentRadioName;
      if (+this.policyHolderType === 1) {
        this.companyName = "大树保";
        this.policyHolderCertificatId = 1;
        this.policyHolderCertificat = "统一社会信用代码";
        this.creditCode = "12312312312";
        this.areaValue = "上海市-上海市-浦东新区";
        this.companyAddress = "亮秀路112号Y1座";
        this.defauleCountyCode = "120103" || "";
      } else {
        this.personalName = "李四";
        this.personalIdCardNum = "320323123123124213";
        this.personalPhoneNum = "18913499673";
        this.personalGender = 1;
        this.birthday = "1994-11-12";
        this.policyHolderCertificatId = 2;
        this.policyHolderCertificat = "军官证";
        this.defaultPickerIndex =
          this.personalCertificatTypes.findIndex(
            (item) => +item.id === 2
          ) || 0;
        this.currentDate = new Date("1994-11-12");
      }
      this.showPolicyHolderSheet = false;
    },

    handlePolicyHolderCancel() {
      this.currentRadioName = this.confirmRadioName;
      this.showPolicyHolderSheet = false;
    },
    // 点击立即投保
    handleConfirm() {
      const errMsg = this.verifyFormData();
      if (errMsg) {
        // 校验投保人
        Notify(errMsg);
      } else {
        if (!this.insuredInfoList.length) {
          Notify("请添加被保人信息");
        } else {
          // 校验被保人
          this.verifyinsuredFormData();
        }
      }
    },
    // 投保人表单校验
    verifyFormData() {
      const {
        policyHolderType,
        companyName,
        personalName,
        creditCode,
        policyHolderCertificatId,
        personalIdCardNum,
        personalPhoneNum,
        areaValue,
        companyAddress,
        personalGender,
        birthday,
      } = this.$data;
      // 企业投保校验
      if (+policyHolderType === 1) {
        const verifyRules = [
          {
            errMsg: "请输入公司名称",
            value: companyName,
            type: "companyName",
          },
          {
            errMsg: "请选择投保人证件类型",
            value: policyHolderCertificatId,
            type: "policyHolderCertificatId",
          },
          {
            errMsg: "请输入社会信用代码",
            value: creditCode,
            type: "creditCode",
          },
          {
            errMsg: "请选择省市区",
            value: areaValue,
            type: "areaValue",
          },
          {
            errMsg: "请输入公司地址",
            value: companyAddress,
            type: "companyAddress",
          },
        ];
        return this.getErrorMsg(verifyRules);
      } else {
        // 个人投保校验规则
        let verifyRules = [];
        if (policyHolderCertificatId > 1) {
          verifyRules = [
            {
              errMsg: "请输入投保人姓名",
              value: personalName,
              type: "personalName",
            },
            {
              errMsg: "请选择投保人证件类型",
              value: policyHolderCertificatId,
              type: "policyHolderCertificatId",
            },
            {
              errMsg: "请输入投保人的证件号码",
              value: personalIdCardNum,
              type: "personalIdCardNum",
            },
            {
              errMsg: "请输入投保人手机号",
              value: personalPhoneNum,
              verifyMsg: "手机号格式不正确",
              type: "personalPhoneNum",
            },
            {
              errMsg: "请选择投保人性别",
              value: personalGender,
              type: "personalGender",
            },
            {
              errMsg: "请选择投保人出生日期",
              value: birthday,
              type: "birthday",
            },
          ];
          return this.getErrorMsg(verifyRules);
        } else {
          verifyRules = [
            {
              errMsg: "请输入投保人姓名",
              value: personalName,
              type: "personalName",
            },
            {
              errMsg: "请选择投保人证件类型",
              value: policyHolderCertificatId,
              type: "policyHolderCertificatId",
            },
            {
              errMsg: "请输入投保人的证件号码",
              value: personalIdCardNum,
              verifyMsg: "身份证格式不正确",
              type: "personalIdCardNum",
            },
            {
              errMsg: "请输入投保人手机号",
              value: personalPhoneNum,
              verifyMsg: "手机号格式不正确",
              type: "personalPhoneNum",
            },
          ];
          return this.getErrorMsg(verifyRules);
        }
      }
    },
    // 错误信息提示
    getErrorMsg(verifyRules) {
      let errorArray = [];
      verifyRules.map((item) => {
        if (!item.value) {
          errorArray.push(item.errMsg);
        } else if (item.verifyMsg) {
          if (item.type === "personalIdCardNum") {
            const personalIdCardNum = verifyCardNo(item.value);
            if (typeof personalIdCardNum !== "boolean") {
              errorArray.push(item.verifyMsg);
            }
          }
          if (item.type === "personalPhoneNum") {
            const personalPhoneNum = isMobile(item.value);
            if (!personalPhoneNum) {
              errorArray.push(item.verifyMsg);
            }
          }
        }
      });
      if (!errorArray.length) return false;
      return errorArray[0];
    },

    // 被保人信息校验
    verifyinsuredFormData() {
      this.insuredInfoList.forEach((item, index) => {
        if (!item.insuredName) {
          item.inSuredPass = false;
          item.errMsg = `请输入被保人${SectionToChinese(
            index + 1
          )}姓名`;
          return;
        }
        if (!item.insuredCertificatId && item.insuredCertificatId !== 0) {
          item.inSuredPass = false;
          item.errMsg = `请选择被保人${SectionToChinese(
            index + 1
          )}证件类型`;
          return;
        }
        if (!item.insuredIdCardNum) {
          item.inSuredPass = false;
          item.errMsg = `请输入被保人${SectionToChinese(
            index + 1
          )}证件号码`;
          return;
        } else if (+item.insuredCertificatId === 0) {
          const isIdCard = verifyCardNo(item.insuredIdCardNum);
          if (typeof isIdCard !== "boolean") {
            item.inSuredPass = false;
            item.errMsg = `被保人${SectionToChinese(
              index + 1
            )}${isIdCard}`;
            return;
          }
        }
        item.inSuredPass = true;
        item.errMsg = "";
      });
      const errArray = this.insuredInfoList.filter(
        (item) => !item.inSuredPass
      );
      if (errArray.length) {
        Notify(errArray[0].errMsg);
        return;
      }
      if (!this.checked) {
        Notify(`请确认已勾选《投保须知及声明》《条款详情》`);
      } else {
        this.handlePolicyParams()
      }
    },
	async handleAreaData(holder){
		const {county_list,city_list,province_list} = areaList
		let provinceCode = findKey(province_list,holder.provinceCode)[0] + '000000' || holder.provinceCode
		let cityCode = findKey(city_list,holder.cityCode)[0] + '000000' || holder.cityCode
		let districtCode = findKey(county_list,holder.districtCode)[0] + '000000' || holder.districtCode
		if(this.serverAreaList.length){
			const provinceModel = this.serverAreaList.find(x=>x.name == holder.provinceCode)
			if(provinceModel && provinceModel.code){
				provinceCode = provinceModel.code
				let currentCode = provinceCode
				for(let i = 0;i < 2; i++){
					if(currentCode){
						const result = await this.getServerArea(currentCode)
						if(result.code == 200 && result.data.length){
							let currentNameCode = holder.cityCode
							if(i == 1){
								currentNameCode = holder.districtCode
							}
							currentCode = result.data.find(x=>x.name == currentNameCode)?.code
							if(currentCode){
								if(i == 0){
									cityCode = currentCode
								}else if(i == 1){
								    districtCode = currentCode
								}
							}else{
								break
							}
						}else{
							break;
						}
					}else{
						break
					}
				}
			}
		}
		return {provinceCode,cityCode,districtCode}
	},
    handleInsuredArrayData() {
      const { insuredInfoList,currentCaseId,productCases,ageRule } = this.$data
      let insuredArray = [];
	  let errMsg = ''
	  let planCode = productCases.find(item => item.id === currentCaseId).value
	  if(planCode.indexOf('-')!=-1){
	  	const productPlanCode = planCode.split('-')
	  	planCode = productPlanCode[1]
	  }
	  let agerule = ageRule[planCode]
      insuredInfoList.forEach((item,index) => {
		  //获取生日
		  const birthDate = +item.insuredCertificatId === 0 ? getBirthdayFromIdCard(item.insuredIdCardNum) : item.birthday
		  //获取年龄差
		  if(agerule && birthDate){
			  const {min,max} = agerule
			  const days = getAge(birthDate,this.startDate)
			  if(days < min || days > max){
				  errMsg = '被保人'+(index+1)+'年龄不符'
				  return
			  }
		  }
		  //获取年龄差
		  
		  //获取性别
		 let gender = 'MALE'
		 const tempGender = item.insuredGender
		 if(item.insuredCertificatId == 0){
			 const newGender = identifyText(item.insuredIdCardNum + ' 测试')
			 if(newGender[0].insuredGender == 'F'){
				 gender = 'FEMALE'
			 }
		 }else{
			 gender = +tempGender == 1?"MALE":"FEMALE"
		 }
		  //获取性别
        insuredArray.push({
          name: item.insuredName,
          idType: item.insuredCertificatId == 0?"ID":item.insuredCertificatId == 2?"PASSPORT":"OTHER",
          idNumber: item.insuredIdCardNum,
          // gender: +item.insuredCertificatId === 0 ? getCardNoSex(item.insuredIdCardNum) : item.insuredGender,
		  // gender: +item.insuredGender == 1?"MALE":"FEMALE",
		  gender:gender,
          birthDate: birthDate
        })
      })
      return errMsg || insuredArray
    },
    handlePolicyParams() {
      // 生成保单参数
      let { productCode, total, productCases, insurances, actions, actionId, currentCaseId, productId, startDate, companyName, creditCode, areaValue, companyAddress, userInfo } = this.$data
	  let planCode = productCases.find(item => item.id === currentCaseId).value
	  const planCodeIndex = productCases.findIndex(item => item.id === currentCaseId)
	  const actionValue = this.actions.find(item => item.id === this.actionId).value.toUpperCase()
	  console.log('planCodeIndex',planCodeIndex)
	  if(+productId == 157 || +productId == 126){
		  productCode = this.hardCodeInsuredData[productId]['productCode']
		  planCode  = this.hardCodeInsuredData[productId][planCodeIndex][actionValue]
	  }
      const attach = JSON.parse(localStorage.getItem('attach')) || ''
      const channelId = JSON.parse(localStorage.getItem('channelId')) || ''
      const policyParams = {
        appKey: 'dsbjkgzh',
        userId: userInfo.id,
        openid: userInfo.openId,
        attach,
        channelId,
        // 保单信息
        policy: {
          productCode,
          planCode: planCode,
          totalPremium: total,
          effectiveDate: startDate,
        },
        product: {
          amount: planCode,
          copys: 1,
          insuranceId: insurances[0].id,
          insuranceterm: actions.find(item => item.id === actionId).value,
          payterm: insurances[0].payPeriod[0].propertyValue,
          productId: productId,
        },
        holder: {
          name: companyName,
          idNumber: creditCode,
          address: companyAddress,
          districtCode: areaValue.split('-')[2],
          cityCode: areaValue.split('-')[1],
          provinceCode: areaValue.split('-')[0],
        },
        insuredArray: this.handleInsuredArrayData(),
      };
      // this.savePolicy(policyParams)
	  this.saveInsuredInfo(policyParams)
    },
	async saveInsuredInfo(policyParams) {
		// console.log('policyParams',JSON.stringify(policyParams))
		const saveProduct = JSON.parse(localStorage.getItem('productInfo'))
		const newCompanyCode = saveProduct.product.company.companyCode
		
		const { currentCaseId,productCases } = this.$data
		const caseData = productCases.find(item => item.id === currentCaseId)
		let {creator='',customerId='',buyUserId='',customerUserId='',sourceType='',token=''} = this.$route.query
		creator = creator.trim();
		customerId = customerId.trim();
		buyUserId = buyUserId.trim();
		customerUserId = customerUserId.trim();
		sourceType = sourceType.trim();
		token = token.trim();
		const { policy, product, holder, insuredArray } = policyParams
		const { productId, insuranceId } = product
		let { productCode,effectiveDate,planCode,totalPremium } = policy
		if((typeof insuredArray=='string')&&insuredArray.constructor==String){
			Notify(insuredArray)
			return
		}
		if(planCode.indexOf('-')!=-1){
			const productPlanCode = planCode.split('-')
			productCode = productPlanCode[0]
			planCode = productPlanCode[1]
		}
		const productQuantity = insuredArray.length
		const totalAmount = totalPremium * productQuantity
		
		const actionValue = this.actions.find(item => item.id === this.actionId).value
		let expireDate = dayjs(effectiveDate).add(1, "month").subtract(1, 'day').format("YYYY-MM-DD")
		if(actionValue.toLowerCase() == 'tyone'){
			expireDate = dayjs(effectiveDate).add(1, "year").subtract(1, 'day').format("YYYY-MM-DD")
		}
		
		//area
		const areaData = await this.handleAreaData(holder)
		
		const newInsuredArray = []
		for(let i = 0;i<insuredArray.length;i++){
			const insuredPersonInfo = insuredArray[i]
			const newInsuredPersonInfo = {}
			newInsuredPersonInfo.birthDate = insuredPersonInfo.birthDate
			newInsuredPersonInfo.idNumber = insuredPersonInfo.idNumber
			newInsuredPersonInfo.effectiveDate = effectiveDate
			newInsuredPersonInfo.gender = insuredPersonInfo.gender
			newInsuredPersonInfo.idType = insuredPersonInfo.idType
			newInsuredPersonInfo.name = insuredPersonInfo.name
			newInsuredArray.push(newInsuredPersonInfo)
		}
		const newData = {
			companyCode:this.companyCode,
			creator:creator,
			customerId:customerId,
			effectiveDate:effectiveDate,
			expireDate:expireDate,
			groupSize:productQuantity,
			totalPremium:totalPremium,
			insuredDTOList:newInsuredArray,
			insuredOrderDTO:{
				accountType:'CUSTOMER',
				buyUserId:buyUserId,
				couponAmount:0.00,
				customerUserId:customerUserId,
				fruitAmount:0.00,
				fruitCount:0,
				orderType:'INSURE',
				payAmount:totalAmount,
				totalAmount:totalAmount,
				planCode:planCode,
				// payType:'NO_PAY',
				productPlanCode:planCode,
				productQuantity:productQuantity,
				sourceType:sourceType,
				productCode: productCode,
				productId: productId,
				productName: this.productName,
				productPrice:totalPremium,
				productCategoryName:'家政保险',
				productPlanId:caseData.id,
				productPlanName:caseData.name,
				imageUrl:this.productPictureUrl,
			},
			policyHolder:{
				name: holder.name,
				idNumber: holder.idNumber,
				address: holder.address,
				districtCode: areaData.districtCode,
				cityCode: areaData.cityCode,
				provinceCode: areaData.provinceCode,
				type:"C",
				idType:'UNIFIED_SOCIAL_CREDIT_CODE',
				companyCode:newCompanyCode,
				// policyHolderType:policyHolderType,
				// policyHolderCertificat:policyHolderCertificat,
				// policyHolderCertificatId:policyHolderCertificatId
			},
			planCode:planCode,
			sourceType:sourceType,
			insuringWay:this.insuredRadio,
			transactionTotalPremium:totalAmount,
			insurancePeriod:actionValue,
			productCode: productCode,
			productId: productId,
			productName: this.productName,
		}
		Toast.loading({
		  message: '加载中',
		  forbidClick: true,
		  duration: 0,
		  loadingType: 'spinner'
		})
		try {
			// console.log('newData',JSON.stringify(newData),token)
		  const data = await saveInsuredInfo(newData,token)
		  // console.log('dataresult',JSON.stringify(data))
		  Toast.clear()
		  if (data.code == 200 && data.data.length) {
		    // this.weixinPay(JSON.parse(data.result))
			const { orderNo } = data.data[0]
			const spliceData = {orderNo,totalAmount,productQuantity,totalPremium,productName:this.productName,productIntro:this.productIntro,productPictureUrl:this.productPictureUrl,}
			// console.log('spliceData',JSON.stringify(spliceData))
			if(sourceType == 'MINI'){
				wx.miniProgram.navigateTo({
				   url:`/pages/course/pay-order/main?policyInfoData=${encodeURIComponent(JSON.stringify(spliceData))}&orderWay=policyOrder`
				})
				wx.miniProgram.postMessage(spliceData)
			}else{
				spliceData.token = true
				window.parent.postMessage(spliceData,'*')
			}
		  }
		} catch (err) {
		  Toast.clear()
		   let {message} = err
		   if(message.indexOf('401')!=-1 || message.indexOf('403')!=-1){
			   message = 'token无效或已过期'
			   Notify(message)
			   const tokenData = {token: false}
			   if(sourceType == 'MINI'){
			   	wx.miniProgram.navigateBack({
			   	    delta: 2
			   	})
			   	wx.miniProgram.postMessage({ data: tokenData })
			   }else{
			   	window.parent.postMessage(tokenData,'*')
			   }
			   return
		   }
		  if(err && err.message){
		  	 Notify(err.message)
		  }
		}
	},
    async savePolicy(policyParams) {
      Toast.loading({
        message: '加载中',
        forbidClick: true,
        duration: 0,
        loadingType: 'spinner'
      })
      try {
        const data = await savePolicy(policyParams)
        Toast.clear()
        if (data.result) {
          this.weixinPay(JSON.parse(data.result))
        }
      } catch (err) {
        Toast.clear()
      }
    },
    weixinPay(data) {
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener("WeixinJSBridgeReady", this.onBridgeReady(data), false);
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady(data));
          document.attachEvent("onWeixinJSBridgeReady", this.onBridgeReady(data));
        }
      } else {
        this.onBridgeReady(data);
      }
    },
    onBridgeReady(data) {
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: data.appId, //公众号名称，由商户传入
          timeStamp: data.timeStamp, //时间戳，自1970年以来的秒数
          nonceStr: data.nonceStr, //随机串
          package: data.packageStr, //订单详情扩展字符串
          signType: data.signType, //微信签名方式：
          paySign: data.sign, //微信签名
        },
        function (res) {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            Notify("支付成功");
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
              history.go(-1);
            }, 3000)
            // ...
          } else {
            alert("支付失败！");
          }
        }
      );
    }
  },
};
</script>
